import { Component } from '@angular/core';

@Component({
    selector: '[cmpsEventCentreCardTarget]',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-event-centre-card-target',
    },
})
export class CardTargetComponent {}
